import { render, staticRenderFns } from "./FormSocialMediaManage.vue?vue&type=template&id=3f7510a6"
import script from "./FormSocialMediaManage.vue?vue&type=script&lang=js"
export * from "./FormSocialMediaManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports